<ion-content class="login --no-bg">
  <div class="login__background"></div>
  <div class="login__content">
    <app-logo class="--big login__content__logo"></app-logo>
    <span class="login__content__title" [innerHTML]="'Prüfen Sie Ihre E-Mail!'"></span>
    <span
      class="login__content__text"
      [innerHTML]="'Wir haben eine E-Mail an ' + email + ' gesendet. Haben Sie sie nicht erhalten? Überprüfen Sie Ihren Spam-Ordner oder versuchen Sie es erneut.'"
    ></span>
    <div class="login__content__form">
      <div class="login__content__form__buttons --forget-password">
        <ion-button
          class="button login__content__form__buttons__button"
          [routerLink]="['..', routes.login]"
          [queryParams]="{ email: email }"
          [innerHTML]="'Na gut!'"
        ></ion-button>
      </div>
    </div>
  </div>
</ion-content>
